import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import css from './index.css';
import FuelCalculator from '../common/fuelCalculator';
import {removeRateCheck, getRateAverage} from '~/modules/rate/actions';
import mapDispatch from '~/misc/mapDispatch';
import Spinner from '~/components/common/Spinner';
import AddressInformation from '../common/addressInformation';
import { getDistance } from '~/api/map'
class RateCalculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      distance: 'undefined'
    }
  }
  componentWillMount() {
    const pickup = this.props.pickup;
    const dropOff = this.props.dropOff;
    const equipment = 'flatbed';
    this.props.getRateAverage({pickup, dropOff, equipment});
    this.getDistance(pickup, dropOff);
  }
  render() {
    if (this.state.distance === 'undefined') {
      return (<div className={cs(css.main)}>
          <div className={css.spinnerLine}>
            <div className={css.spinner}>
              <Spinner scalable={true}/>
            </div>
          </div>
      </div>);
    }
    return (
      <div className={cs(css.main)}>
        <div className={cs(css.calculatorTitle)}>Fuel Surcharge Calculator</div>
        <div className={cs(css.calculatorContent)}>
          <div className={cs(css.address)}>
            <AddressInformation pick={this.props.pick} drop={this.props.drop}/>
          </div>
          <FuelCalculator
            bring='true'
            pick={this.props.pick}
            drop={this.props.drop}
            pickup={this.props.pickup}
            dropOff={this.props.dropOff}
            fuelPrice={this.props.fuelPrice}
            basePrice={this.props.basePrice}
            milesPrice={this.props.milesPrice}
            distance={this.state.distance}
          />
        </div>
      </div>
    );
  }
  componentWillUnmount() {
    this.props.removeRateCheck();
  }
  getDistance (latLngFrom, latLgnTo) {
    getDistance(latLngFrom, latLgnTo).then(distance=> {
      this.setState({distance: distance});
    })
  }
}
export default connect(({rate}, {location: {query: {param}}}) => {
  const data = JSON.parse(param);
  const pickup = {
    lng: data.origin.lng,
    lat: data.origin.lat,
    city: data.origin.city,
    state: data.origin.state,
  };
  const dropOff = {
    lng: data.destination.lng,
    lat: data.destination.lat,
    city: data.destination.city,
    state: data.destination.state,
  };
  return {
    pick: data.origin.name,
    drop: data.destination.name,
    pickup: pickup,
    dropOff: dropOff,
    fuelPrice: data.fuelPrice,
    basePrice: data.basePrice,
    milesPrice: data.milesPrice
  };
}, mapDispatch({
  removeRateCheck: (props) => removeRateCheck(),
  getRateAverage: (props, data) => getRateAverage(data),
}))(RateCalculator);



// WEBPACK FOOTER //
// ./src/components/rate/calculator/index.js